import * as z from "zod/mini";

// TODO/typescript: Move this to server_events
export const topic_link_schema = z.object({
    text: z.string(),
    url: z.string(),
});

export type TopicLink = z.infer<typeof topic_link_schema>;

export const user_badge_info_schema = z.object({
    badge: z.string(),
    animated_badge: z.string(),
    description: z.string(),
});

export type UserBadgeInfo = z.infer<typeof user_badge_info_schema>;

export const left_sidebar_icon_schema = z.discriminatedUnion("type", [
    z.object({type: z.literal("zulip_icon"), name: z.string()}),
    z.object({type: z.literal("emoji"), name: z.string()}),
]);

export type LeftSidebarIcon = z.infer<typeof left_sidebar_icon_schema>;

export const left_sidebar_link_schema = z.object({
    text: z.string(),
    url: z.string(),
    icon: left_sidebar_icon_schema,
});

export type LeftSidebarLink = z.infer<typeof left_sidebar_link_schema>;

export const left_sidebar_category_schema = z.object({
    title: z.string(),
    links: z.array(left_sidebar_link_schema),
    block_id: z.string(),
    override: z.boolean(),
});

export type LeftSidebarCategory = z.infer<typeof left_sidebar_category_schema>;

export type HTMLSelectOneElement = HTMLSelectElement & {type: "select-one"};

export const anonymous_group_schema = z.object({
    direct_subgroups: z.array(z.number()),
    direct_members: z.array(z.number()),
});

export const group_setting_value_schema = z.union([z.number(), anonymous_group_schema]);

export const COMPONENT_INTENT_VALUES = [
    "neutral",
    "brand",
    "info",
    "success",
    "warning",
    "danger",
] as const;

export type ComponentIntent = (typeof COMPONENT_INTENT_VALUES)[number];
